import * as React from 'react';
import {
	Create,
	CreateProps,
	SimpleForm,
	TextInput
} from 'react-admin';

export const TagCreate = (props: CreateProps): React.ReactElement => {
	return (
		<Create {...props}>
			<SimpleForm>
				<TextInput step={1} source="title" label="TITLE"/>
			</SimpleForm>
		</Create>
	);
};
